import { useEffect } from 'react'
import { selectEulaSetting } from '../slices/settings.slice'
import { useStore } from 'react-redux'
import dayjs from 'dayjs'
import { EULA_ACCEPTED_DAY } from '../constants'

const INLINE_MANUAL_PLAYER_UUID = 'inline-manual-people-uuid'

const EXPIRES_DAYS = 90

const generateUniqueId = () => {
  const randomPart = crypto.getRandomValues(new Uint32Array(1))[0].toString(16)
  const timestampPart = Date.now().toString(16)
  return `${randomPart}-${timestampPart}`
}

const isMoreThan90Days = (date1, date2) => {
  const diff = Math.abs(dayjs(date1).diff(dayjs(date2), 'day'))
  return diff >= EXPIRES_DAYS
}

const enablePeopleTracking = () => {
  const { getState } = useStore()
  const isEulaAccepted = selectEulaSetting(getState())

  let peopleUid = localStorage.getItem(INLINE_MANUAL_PLAYER_UUID)

  useEffect(() => {
    if (!peopleUid) {
      peopleUid = generateUniqueId()
      localStorage.setItem(INLINE_MANUAL_PLAYER_UUID, peopleUid)
    }

    if (isEulaAccepted && !localStorage.getItem(EULA_ACCEPTED_DAY)) {
      localStorage.setItem(EULA_ACCEPTED_DAY, new Date().toISOString())
    }

    if (
      !isEulaAccepted ||
      !isMoreThan90Days(new Date().toISOString(), localStorage.getItem(EULA_ACCEPTED_DAY))
    )
      return

    window.inlineManualTracking = {
      uid: peopleUid,
    }
  }, [])
}

export { enablePeopleTracking }
